import {
  BanknotesIcon,
  BuildingLibraryIcon,
  CreditCardIcon,
  DevicePhoneMobileIcon,
  DocumentTextIcon,
  WalletIcon,
} from '@heroicons/react/24/outline'

const normalize = (value) =>
  String(value || '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')

export const resolvePaymentMethodIcon = (method, label = '') => {
  const hay = normalize(
    [label, method?.label, method?.name, method?.code, method?.type, method?.description]
      .filter(Boolean)
      .join(' '),
  )

  if (hay.includes('espece') || hay.includes('cash') || hay.includes('liquide')) {
    return BanknotesIcon
  }
  if (
    hay.includes('carte') ||
    hay.includes('card') ||
    hay.includes('cb') ||
    hay.includes('visa') ||
    hay.includes('mastercard')
  ) {
    return CreditCardIcon
  }
  if (
    hay.includes('virement') ||
    hay.includes('transfer') ||
    hay.includes('bank') ||
    hay.includes('iban')
  ) {
    return BuildingLibraryIcon
  }
  if (hay.includes('cheque') || hay.includes('check')) {
    return DocumentTextIcon
  }
  if (
    hay.includes('mobile') ||
    hay.includes('wallet') ||
    hay.includes('paypal') ||
    hay.includes('orange money') ||
    hay.includes('d17')
  ) {
    return DevicePhoneMobileIcon
  }
  return WalletIcon
}
